import WidgetWrapper from "../../WidgetWrapper";
import RutonyChat from "./RutonyChat";

export default function RutonyChatPage() {
  return (
    <WidgetWrapper>
      <RutonyChat />
    </WidgetWrapper>
  );
}
